export default __webpack_public_path__ + "static/media/back-soon.947eda15.svg";